<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <!-- Start Main Section -->
    <main class="row justify-content-center">
      <div class="col-12">
        <div class="profile_wrapper">
          <img :src="data.image" />
          <h4>{{ data.fullname }}</h4>
          <p>{{ data.phone }}</p>
          <p>{{ data.email }}</p>
          <p>{{ data.gender_trans }}</p>
          <div class="details">
            <span>أخر تسجيل دخول</span>
            <span>{{ data.last_login_at }}</span>
          </div>
          <div class="details">
            <span>
              عنوان الجهاز
            </span>
            <span>
              {{ data.ip }}
            </span>
          </div>
          <div class="edit_button">
            <router-link to="/settings/profile/update">
              <i class=""></i>
              تعديل معلوماتك
            </router-link>
          </div>
        </div>
      </div>
      <v-expansion-panels class="col-12">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h5>تغيير كلمة المرور</h5>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <form @submit.prevent="validateCreateForm">
              <div class="row justify-content-center">
                <div class="col-lg-6">
                  <div class="input_wrapper animated_placeholder">
                    <label for="login_pass" class="form-label">
                      {{ $t("forms.labels.currentPassword") }}
                    </label>

                    <div
                      class="tw-relative tw-flex tw-items-center tw-justify-between"
                    >
                      <input
                        :type="showPassword ? 'text' : 'password'"
                        class="form-control"
                        :placeholder="$t('forms.labels.currentPassword')"
                        v-model.trim="password.old"
                        @input="helper_checkIfInputIsEmpty"
                      />
                      <button
                        type="button"
                        class="toggle_pass_btn tw-absolute tw-end-[13px]"
                        @click="showPassword = !showPassword"
                      >
                        <i
                          v-if="showPassword"
                          class="fal fa-eye-slash closed_eye"
                        ></i>
                        <i v-else class="fal fa-eye open_eye"></i>
                      </button>
                    </div>
                  </div>
                  <div class="input_wrapper animated_placeholder">
                    <label for="login_pass" class="form-label">
                      {{ $t("forms.labels.password") }}
                    </label>

                    <div
                      class="tw-relative tw-flex tw-items-center tw-justify-between"
                    >
                      <input
                        :type="showNPassword ? 'text' : 'password'"
                        class="form-control"
                        :placeholder="$t('forms.labels.password')"
                        v-model.trim="password.new"
                        @input="helper_checkIfInputIsEmpty"
                      />
                      <button
                        type="button"
                        class="toggle_pass_btn tw-absolute tw-end-[13px]"
                        @click="showNPassword = !showNPassword"
                      >
                        <i
                          v-if="showNPassword"
                          class="fal fa-eye-slash closed_eye"
                        ></i>
                        <i v-else class="fal fa-eye open_eye"></i>
                      </button>
                    </div>
                  </div>
                  <div class="input_wrapper animated_placeholder">
                    <label for="login_pass" class="form-label">
                      {{ $t("forms.labels.cPassword") }}
                    </label>

                    <div
                      class="tw-relative tw-flex tw-items-center tw-justify-between"
                    >
                      <input
                        :type="showCPassword ? 'text' : 'password'"
                        class="form-control"
                        :placeholder="$t('forms.labels.cPassword')"
                        v-model.trim="password.confirm"
                        @input="helper_checkIfInputIsEmpty"
                      />
                      <button
                        type="button"
                        class="toggle_pass_btn tw-absolute tw-end-[13px]"
                        @click="showCPassword = !showCPassword"
                      >
                        <i
                          v-if="showCPassword"
                          class="fal fa-eye-slash closed_eye"
                        ></i>
                        <i v-else class="fal fa-eye open_eye"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttons_wrapper">
                <button
                  class="base-btn"
                  :class="btnIsLoading ? 'disabled' : ''"
                >
                  {{ $t("forms.submit") }}
                  <span class="btn_loader" v-if="btnIsLoading"></span>
                </button>
              </div>
            </form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </main>
    <!-- End Main Section -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.profile.title"),
          disabled: false,
          href: "/settings/profile",
        },
        {
          text: this.$t("breadcrumb.profile.all"),
          disabled: true,
          href: "",
        },
      ],
      showPassword: false,
      showCPassword: false,
      showNPassword: false,
      // ========== Loding
      lodaing: false,
      data: {},
      password: {
        old: null,
        new: null,
        confirm: null,
      },
    };
  },

  watch: {},

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
  },

  methods: {
    editPassword() {
      this.$router.push({ path: "/settings/profile/edit_password" });
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.password.old) {
        this.$iziToast.error({
          timeout: 2000,
          message: " ادخل كلمة المرور الحالية",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.password.new) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ادخل كلمة المرور الجديدة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.password.confirm) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل تأكيد كلمة المرور",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
        // } else if (!this.password.new.length > 7) {
        //   this.$iziToast.error({
        //     timeout: 2000,
        //     message: '  كلمة المرور يجب ان يكون طولها  اكبر من 7 احرف او ارقام  ',
        //     position: 'bottomRight',
        //   })
        //   this.btnIsLoading = false
        //   return
      } else if (!this.password.new === this.password.confirm) {
        this.$iziToast.error({
          timeout: 2000,
          message: " كلمة المرور وكلمة  تأكيد المرور ليس نفس الشئ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();

      submit_data.append("old_password", this.password.old);
      submit_data.append("password", this.password.new);

      submit_data.append("password_confirmation", this.password.confirm);
      submit_data.append("_method", "PUT");

      this.axios({
        method: "POST",
        url: "profile/update_password",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          // this.$router.push({ path: "/settings/profile" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getData() {
      this.axios({
        method: "GEt",
        url: "profile/show",
      })
        .then((res) => {
          if (res.data.data) {
            this.data = res.data.data;
          }
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  // ======= hooks
  created() {
    // Set Rows
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.profile_wrapper {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  // @include mainShadow;
  border-radius: 20px;
  // height: 100vh;
  row-gap: 10px;
  padding-block: 30px;
  img {
    width: 200px;
    height: 200px;
    border-radius: 15px;
    margin-inline: auto;
  }
  h4 {
    font-size: 20px;
  }
  p {
    color: var(--mainClr-2);
    font-size: 16px;
  }
  .details {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-inline: 10px;
    span {
      font-size: 18px;
      color: var(--mainColor-1_1);
    }
    span:last-of-type {
      color: var(--mainColor-2);
    }
  }
  .edit_button {
    width: 80%;
    margin-inline: auto;
    a {
      color: #fff;
      font-size: 16px;
      background: var(--mainColor-2);
      border-radius: 10px;
      width: 100%;
      max-width: 200px;
      margin-inline: auto;
      padding-inline: 20px;
      line-height: 50px;
      display: block;
      margin-block-start: 15px;
      text-align: center;
      transition: all 0.5s linear;
      border: 2px solid var(--mainColor-2);
      &:hover {
        color: var(--mainColor-2);
        background: #fff;
      }
    }
  }
}
</style>
